import { gql } from "@apollo/client";
export const ADMIN_WINERY_MEMBER_GROUP_DELETE = gql `
  mutation AdminWineryDelete($input: AdminWineryDeleteInput!) {
    AdminWineryDelete(input: $input)
  }
`;
